import { Box } from '@mui/material'
import React, { useContext, useEffect } from 'react'
import { Mobile } from './/mobile/Index'
import { Desktop } from './desktop/Index'
import { Tablet } from './tablet/Index'
import { ToolContext } from '../../../../../../core/context/ToolContext'
import { env } from '../../../../../../core/Env'
import { rqx } from '../../../../../../core/request/API'


const View = () => {
  const { salespage_state } = useContext(ToolContext)
  const { cmtznLoader, viewdata } = salespage_state;
  const urlParams = new URLSearchParams(window.location.search);
  const view = urlParams.get("tab");

  const __initView = async () => {
    cmtznLoader.set(true)
    const l = await rqx.get(`<<tool>>/${env()}/realProperty/viewList`, { id: urlParams.get('id') })
    viewdata.set({
      id: l[0].id,
      designs: JSON.parse(l[0].design),
      content: JSON.parse(l[0].content)
    })
    cmtznLoader.set(false)
  }
  

  useEffect(() => {
    if (view === "mobile" || view === "tablet" || view === "desktop") {
      __initView()

    }

    // eslint-disable-next-line
  }, [])

  return (
    <Box width="100%" height="100%" pb={2}>
      {
        view === "mobile" ? <Mobile cmtznLoader={cmtznLoader} viewdata={viewdata} />
          :
          view === "tablet" ? <Tablet cmtznLoader={cmtznLoader} viewdata={viewdata} />
            :
            <Desktop cmtznLoader={cmtznLoader} viewdata={viewdata} />
      }
    </Box>
  )
}

export default View